module.exports = __webpack_public_path__ + "dingbeauty/admin/img/pet-avatar-default@2x.5eaf0385.png";